/**
 * 秒数を mm:ss 形式の文字列にフォーマットする（例: 75 → "01:15"）。
 * 0 未満は 0 として扱う。
 *
 * 主に OTP 認証コードの残り有効時間表示に使用する。
 */
export const formatRemainingTime = (seconds: number): string => {
  const safe = Math.max(0, Math.floor(seconds));
  const minutes = Math.floor(safe / 60);
  const remainSec = safe % 60;
  return `${minutes.toString().padStart(2, '0')}:${remainSec.toString().padStart(2, '0')}`;
};
